/**
 * Where the tasks are, worked out from the address and nothing else.
 *
 * `#/tasks` is the list, `#/tasks/new` is the cursor in the field at the top with nothing yet created,
 * and `#/tasks/<id>` is one task opened. The middle one is a *place* rather than a state held in a
 * component, so that the search can send somebody straight into writing an open point down — and so
 * that a reload lands where they were.
 */

export const TASKS_AREA = 'tasks'

/** The step that means "the field at the top has the cursor", without anything being created. */
export const NEW = 'new'

export interface Opened {
  /** Whether the field at the top should take the cursor. */
  readonly writing: boolean
  /** The task that is open, or `null`. */
  readonly taskId: string | null
}

export function openedIn(path: readonly string[]): Opened {
  const [step] = path
  if (step === undefined) {
    return { writing: false, taskId: null }
  }
  if (step === NEW) {
    return { writing: true, taskId: null }
  }
  return { writing: false, taskId: step }
}

/** The address of one task. */
export function pathTo(taskId: string): string[] {
  return [taskId]
}
